import React, { useState, useEffect } from 'react';
import { Col, Container, Input, Label, Row } from 'reactstrap';
import { APIClient } from '../../helpers/api_helper';
import * as url from '../../helpers/url_helper';
import { Navigate, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Loader from '../../Components/Common/Loader';
import GGHLogo from '../../assets/images/logoGGHM.svg';
import logoBg from '../../assets/images/loginbg.png';
import { useDispatch } from 'react-redux';
import { handleUserData } from '../../slices/UserData/reducer';
import Banner from '../../assets/images/verification.png';
import search from '../../assets/animations/search.gif';
import verifivationCompleted from '../../assets/animations/verifivationCompleted.gif';

const AuthorizeUser = () => {
    const api = new APIClient();
    const navigate = useNavigate();
    const dispatch = useDispatch();

    const [selectedDate, setSelectedDate] = useState('');
    const [loader, setLoader] = useState(false);
    const [verify, setVerify] = useState(false);
    const [passwordShow, setPasswordShow] = useState(false);
    let languagesList = [];
    let carePlanObj = {};
    // const [languages, setLanguages] = useState();

    const handleDateChange = (e) => {
        const value = e.target.value;
        setSelectedDate(value);
    };

    const formatDate = (date) => {
        const d = new Date(date);
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, '0'); // Months are 0-based
        const day = String(d.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
    };

    const urlPath = window.location.pathname;
    let [lang, uniquelink, uniquekey] = [];
    let environment = '';
    let xpLang = '';

    if (urlPath.includes('xp')) {
        environment = 'xp';
        const ids = urlPath.split('/authorize/xp/')[1];
        const idslength = ids?.split('/')?.length;
        if (idslength > 2) {
            [lang, uniquelink, uniquekey] = ids?.length > 0 ? ids?.split('/') : [];
            // Validate the language
            if (lang && lang !== 'en' && lang !== 'es') {
                return <Navigate to={{ pathname: '/authorize', state: { from: urlPath } }} />;
            }

            xpLang = lang;
        } else {
            [uniquelink, uniquekey] = ids?.length > 0 ? ids?.split('/') : [];
            lang = 'en';
            xpLang = '';
        }
    } else {
        environment = 'legacy';
        const ids = urlPath.split('/authorize/')[1];
        uniquelink = ids;
        lang = 'en';
        xpLang = 'en';
    }

    const getLanguages = () => {
        return api.webGet(url.GET_AUTH_CONTENT(), {}, true).then((res) => {
            languagesList = res?.data;
        });
    };

    const geCarePlantContent = () => {
        return api.webGet(url.GET_CAREPLAN_CONTENT(), {}, true).then((res) => {
            carePlanObj = res?.data;
        });
    };

    const handleDobSubmit = () => {
        setLoader(true);

        // Fetch both languages and carePlanContent in parallel
        Promise.all([getLanguages(), geCarePlantContent()])
            .then(() => {
                // Once both promises are resolved, continue with the rest of your logic
                urlPath.includes('xp')
                    ? api
                          .get(url.GET_AUTH_TOKEN(lang, uniquelink, uniquekey, selectedDate))
                          .then((res) => {
                              if (res?.isSuccess) {
                                  setLoader(false);
                                  setSelectedDate('');
                                  // toast.success('Validated Successfully');
                                  if (res?.errorMessage !== null) {
                                      setVerify(false);
                                      toast.error(res?.errorMessage.join(','));
                                  } else {
                                      setVerify(true);
                                      toast.success('Validated Successfully');
                                      setTimeout(() => {
                                          setVerify(false);
                                          dispatch(handleUserData(res.data));
                                          navigate('/careplan', {
                                              state: { lang, uniquelink, uniquekey, environment, languagesList, carePlanObj, xpLang }
                                          });
                                      }, 300);
                                  }
                              } else {
                                  // navigate('/careplan', { state: { uniquelink, uniquekey } });
                                  toast.error('Invalid Credentials');
                                  setLoader(false);
                                  setSelectedDate('');
                              }
                          })
                          .catch((error) => {
                              setLoader(false);
                              setSelectedDate('');
                          })
                    : api
                          .get(url.GET_AUTH_TOKEN_LEGASY(uniquelink, selectedDate))
                          .then((res) => {
                              if (res?.isSuccess) {
                                  setLoader(false);
                                  setSelectedDate('');
                                  // toast.success('Validated Successfully');
                                  if (res?.errorMessage !== null) {
                                      setVerify(false);
                                      toast.error(res?.errorMessage.join(','));
                                  } else {
                                      setVerify(true);
                                      toast.success('Validated Successfully');
                                      setTimeout(() => {
                                          setVerify(false);
                                          dispatch(handleUserData(res.data));
                                          navigate('/careplan', { state: { uniquelink, environment, languagesList, carePlanObj, xpLang } });
                                      }, 300);
                                  }
                              } else {
                                  toast.error('Invalid Credentials');
                                  setLoader(false);
                                  setSelectedDate('');
                              }
                          })
                          .catch((error) => {
                              setLoader(false);
                              setSelectedDate('');
                          });
            })
            .catch((error) => {
                // Handle the case where either getLanguages or geCarePlantContent fails
                setLoader(false);
                setSelectedDate('');
                toast.error('Failed to load required data');
            });
    };
    return (
        <>
            {/* {loader && (
                <div className="freeze-spinner">
                    <Loader />
                </div>
            )} */}
            <Container fluid className="vh-80">
                <Row className="h-80">
                    <Col lg={9} md={7} sm={12} className="p-0">
                        <div className="w-100 h-80 position-relative">
                            <img src={logoBg} alt="page-header" className="img-fluid w-100 h-80 object-fit-cover" />
                        </div>
                    </Col>

                    <Col lg={3} md={5} sm={12} className="p-3 bg-white px-0 pt-0 custom-bg-col">
                        <div className="text-center w-100">
                            <div className="d-flex align-items-center justify-content-center">
                                <img src={GGHLogo} alt="Logo" className="main-logo" />
                            </div>
                            {loader && (
                                <div className="mt-4">
                                    <img src={search} alt="search"></img>
                                </div>
                            )}
                            {verify && (
                                <div className="mt-4">
                                    <img src={verifivationCompleted} alt="search"></img>
                                </div>
                            )}
                            {!loader && !verify && (
                                <div>
                                    <div className="mt-4">
                                        <img src={Banner} alt="verificationLogo"></img>
                                    </div>
                                    <div className="text-center px-3">
                                        <h6 className="text-justify">
                                            {' '}
                                            {lang.toUpperCase() === 'EN' ? (
                                                <>
                                                    To access your care plan, please enter your date of birth as
                                                    <span className="font-weight-bold"> MMDDYYYY</span>
                                                </>
                                            ) : (
                                                <>
                                                    GroundGame.Health ayuda a las personas a encontrar programas y servicios para mejorar su
                                                    salud y bienestar. Hemos creado un plan de apoyo personalizado que identifica en qué
                                                    áreas podemos ayudarle y brindarle recursos útiles cerca de usted. Para acceder a su
                                                    plan, ingrese su fecha de nacimiento en el formato MMDDYYYY (por ejemplo, 05311990).
                                                </>
                                            )}
                                        </h6>
                                    </div>
                                    <div className="d-flex justify-content-center mt-4">
                                        <div className="auth-pass-inputgroup input-group mb-2 w-60 position-relative">
                                            <Input
                                                name="dateofbirth"
                                                value={selectedDate || ''}
                                                type={passwordShow ? 'text' : 'password'}
                                                className="form-control"
                                                placeholder="MMDDYYYY"
                                                onChange={handleDateChange}
                                                onWheel={(e) => e.target.blur()}
                                                data-date=""
                                                data-date-format="MMDDYYYY"
                                                onKeyDown={(e) => {
                                                    if (!/[0-9]/.test(e.key) && e.key !== 'Backspace') {
                                                        e.preventDefault();
                                                    }
                                                }}
                                            />

                                            {selectedDate !== '' && (
                                                <button
                                                    className="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted zindex99"
                                                    type="button"
                                                    id="password-addon"
                                                    onClick={() => setPasswordShow(!passwordShow)}
                                                >
                                                    <i className="ri-eye-fill align-middle "></i>
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                    <div>
                                        {selectedDate?.length > 8 && (
                                            <>
                                                {lang.toUpperCase() === 'EN' ? (
                                                    <div className="text-danger">
                                                        Please enter your date of birth in the format{' '}
                                                        <span className="font-weight-bold"> MMDDYYYY</span>
                                                    </div>
                                                ) : (
                                                    <div className="text-danger">
                                                        ingrese su fecha de nacimiento en el formato{' '}
                                                        <span className="font-weight-bold"> MMDDYYYY</span>
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    <div className="d-flex justify-content-center">
                                        <button
                                            className="btn btn-primary w-70"
                                            onClick={handleDobSubmit}
                                            disabled={selectedDate?.length !== 8 || loader}
                                        >
                                            {lang.toUpperCase() === 'EN' ? 'Verify' : 'Verificar'}
                                        </button>
                                    </div>
                                </div>
                            )}
                        </div>
                    </Col>
                </Row>
            </Container>
        </>
    );
};

export default AuthorizeUser;
